// The Govern360 logo — "Sentinel" shield-eye mark.
//
// A shield (governance / trust) containing a watching eye (oversight /
// vigilance). Two variants:
//   - console : midnight body, steel-blue iris
//   - admin   : amber accent so staff can tell which console they're in
//
// Replaces the earlier check-in-a-circle mark across both apps.

export default function LogoMark({ variant = 'console', size = 32 }) {
  const isAdmin = variant === 'admin';
  const body = isAdmin ? '#3a2400' : '#11243C';   // shield fill
  const accent = isAdmin ? '#f59e0b' : '#3D8BD4';  // shield outline + iris
  const ring = '#ffffff';                          // eye outline

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={size}
      height={size}
      role="img"
      aria-label="Govern360"
    >
      <rect width="100" height="100" rx="24" fill={body} />
      <path
        d="M50 16 L80 27 L80 52 C80 70 67 82 50 88 C33 82 20 70 20 52 L20 27 Z"
        fill="none"
        stroke={accent}
        strokeWidth="4"
      />
      <ellipse cx="50" cy="52" rx="22" ry="15" fill="none" stroke={ring} strokeWidth="4" />
      <circle cx="50" cy="52" r="7" fill={accent} />
    </svg>
  );
}
